import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { aavnIshcmcEnv, bisHanoiDevEnv, bisHanoiEnv, bisHanoiStagingEnv, demoHelenEnv, ishcmcEnv, isspEnv, primaryIshcmcEnv, secondaryIshcmcEnv } from '../../../config/config';
import { PasswordService } from '../services/PasswordService';


@Component({
    selector: 'user-change-password',
    template: require('./ChangePasswordComponent.html'),
    styles: [require('./ChangePasswordComponent.sass')],
})

export class ChangePasswordComponent implements OnInit {
    message: string;
    messageType: string;

    private redirectUrl = "booking/students";
    private formSubmitted: boolean = false;
    private oldPassword: string;
    private newPassword: string;
    private confirmNewPassword: string;
    private hostName: any;
    protected devEnv: any = ['services.eca.nascorp.vn','camp.eca.nascorp.vn', 'asa.eca.nascorp.vn', 'holiday.eca.nascorp.vn', 'bus.eca.nascorp.vn'];
    protected demoEnv: any = ['services.demo.nascorp.vn','camp.demo.nascorp.vn', 'asa.demo.nascorp.vn', 'holiday.demo.nascorp.vn', 'bus.demo.nascorp.vn'];
    protected testEnv: any = ['services.eca.test.nascorp.vn','camp.eca.test.nascorp.vn', 'asa.eca.test.nascorp.vn', 'holiday.eca.test.nascorp.vn', 'bus.eca.test.nascorp.vn'];
    protected stagingEnv: any = ['staging.services.aisvietnam.com','staging.outdooreducation.aisvietnam.com', 'staging.asa.aisvietnam.com', 'staging.holidayschool.aisvietnam.com', 'staging.bus.aisvietnam.com'];
    protected procEnv: any = ['services.aisvietnam.com','outdooreducation.aisvietnam.com', 'asa.aisvietnam.com', 'holidayschool.aisvietnam.com', 'bus.aisvietnam.com']
    
    constructor(
        private passwordService: PasswordService,
        private router: Router
    ) { }

    ngOnInit() {
        this.message = "";
        this.messageType = "";
        this.hostName = window.location.hostname;
        console.log(this.hostName)
    }

    onSubmit() {
        // Mark form as submitted to disable submit button
        this.formSubmitted = true;
        
        // Reset form alert message 
        this.message = "";
        this.messageType = "";

        this.changePassword(this.oldPassword, this.newPassword);
    }

    private changePassword(oldPassword:string, newPassword: string) {
        this.passwordService.setNewPassword(oldPassword, newPassword)
            .subscribe(
                complete => {
                    if(this.devEnv.indexOf(this.hostName) !== -1){
                        return window.location.href = 'http://services.eca.nascorp.vn/';
                    }
                    else if(this.demoEnv.indexOf(this.hostName) !== -1){
                        return window.location.href = 'http://services.demo.nascorp.vn/';
                    }
                    else if(bisHanoiEnv.indexOf(this.hostName) !== -1){
                        return window.location.href = `http://${bisHanoiEnv.services}`;
                    }
                    else if(bisHanoiDevEnv.indexOf(this.hostName) !== -1){
                        return window.location.href = `http://${bisHanoiDevEnv.services}`;
                    }
                    // else if(isHostInEnv(bisHanoiStagingEnv, this.hostName)){
                    //     return window.location.href = `http://${bisHanoiStagingEnv.services}`;
                    // }
                    // else if(isHostInEnv(ishcmcEnv, this.hostName)){
                    //     return window.location.href = `http://${ishcmcEnv.services}`;
                    // }
                    // else if(isHostInEnv(aavnIshcmcEnv, this.hostName)){
                    //     return window.location.href = `http://${aavnIshcmcEnv.services}`;
                    // }
                    // else if(isHostInEnv(primaryIshcmcEnv, this.hostName)){
                    //     return window.location.href = `http://${primaryIshcmcEnv.services}`;
                    // }
                    // else if(isHostInEnv(secondaryIshcmcEnv, this.hostName)){
                    //     return window.location.href = `http://${secondaryIshcmcEnv.services}`;
                    // }
                    // else if(isHostInEnv(isspEnv, this.hostName)){
                    //     return window.location.href = `http://${isspEnv.services}`;
                    // }
                    // else if(isHostInEnv(demoHelenEnv, this.hostName)){
                    //     return window.location.href = `http://${demoHelenEnv.services}`;
                    // }
                    else if(this.testEnv.indexOf(this.hostName) !== -1){
                        return window.location.href = 'http://services.eca.test.nascorp.vn/';
                    }
                    else if(this.stagingEnv.indexOf(this.hostName) !== -1){
                        return window.location.href = 'http://staging.services.aisvietnam.com/';
                    }
                    else if(this.procEnv.indexOf(this.hostName) !== -1){
                        return window.location.href = 'https://services.aisvietnam.com/';
                    }
                    else{
                        return window.location.href = 'http://services.local.eca.nascorp.vn/';
                    }
                },
                error => {
                    this.message = "Invalid old password input.";
                    this.messageType = "alert";
                    this.formSubmitted = false;
                }
            )
    }

    private redirect(redirectUrl: string) {
        this.router.navigate([redirectUrl]);
    }
}


// WEBPACK FOOTER //
// ./src/common/modules/user/change-password/ChangePasswordComponent.ts